$(function() {
	$('[data-accordion]').each(function() {
		var index = $(this).attr('data-accordion');
		var MultiShow = $(this).attr('data-multiaccordion'); /* Change 'True' If You Want To Show Only one Open Accordion in Same Time */

		$('[data-accordion="' + index + '"] [data-accordion-list="' + index + '"] .accordion-toggle').on('click', function() {


			if (MultiShow === 'true') {

				/* Close All Open Accordion */
				if ($(this).parent().hasClass('open')) {
					/* Close Current Open Accordion If Click On It When Open */
					$(this).parent().removeClass('open');
					$(this).parent().find('.accordion-content').slideUp(360);
				} else {
					/* Close All Open Accordion */
					$(this).parents('[data-accordion-list="' + index + '"]').find('li').removeClass('open');
					$(this).parents('[data-accordion-list="' + index + '"]').find('.accordion-content').slideUp(360);

					/* Open Current Accordion */
					$(this).parent().addClass('open');
					$(this).parent().find('.accordion-content').slideDown(360);
				}

			} else {

				/* Open Current Accordion */
				$(this).parent().toggleClass('open');
				$(this).parent().find('.accordion-content').slideToggle(360);

			}

		});
	});
})